import type { AppRegion } from "@core-types/region.enum";
import LolRegionHelper from "@helpers/regions/LolRegionHelper";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface RegionStore {
  region: AppRegion;
  setRegion: (region: AppRegion) => void;
  getRegion: () => AppRegion;
}

const useRegionStore = create<RegionStore>()(
  persist(
    (set) => ({
      region: LolRegionHelper.DEFAULT_REGION,
      setRegion: (region) => {
        set({ region });
      },
      getRegion: (): AppRegion => {
        const state = useRegionStore.getState();
        if (state.region) {
          return state.region;
        }
        useRegionStore.setState({ region: LolRegionHelper.DEFAULT_REGION });
        return LolRegionHelper.DEFAULT_REGION;
      },
    }),
    { name: "SecretSmurfsStoreRegion" },
  ),
);

/**
 * This is not a hook, and should only be used outside of react components
 */
export const getSelectedRegion = () => {
  return useRegionStore.getState().region;
};

export default useRegionStore;

export const getRegion = (): AppRegion => {
  const { getRegion } = useRegionStore();

  return getRegion();
};
